import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { MenuParameters } from './menu-parameters.model';
import { MenuService } from '../shared/header/menu/menu.service';
import { LanguageService } from '../core/language/language.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../shared/header/menu/menu.service";
import * as i3 from "../core/language/language.service";
var FullMenuService = /** @class */ (function () {
    function FullMenuService(route, menuService, languageService) {
        var _this = this;
        this.route = route;
        this.menuService = menuService;
        this.languageService = languageService;
        this.menu$ = new BehaviorSubject(new MenuParameters(null, null, null));
        this.selectedMenuCategory$ = new BehaviorSubject(null);
        this.selectedSortType$ = new BehaviorSubject('views');
        /*CSCSATIVA-5528 - Navegação via Tab menu e categorias*/
        this.selectedTabindexMenu$ = new BehaviorSubject(null);
        this.selectedTranslationKeyCategory$ = new BehaviorSubject('');
        this.menuParameters = new MenuParameters(null, null, null);
        this.menuService.getMenu().subscribe(function (menuList) {
            _this.menuList = menuList;
            _this.filterMenuByCategory(_this.menuParameters.name);
        });
    }
    FullMenuService.prototype.getSortType = function () {
        return this.selectedSortType$.asObservable();
    };
    FullMenuService.prototype.setSortType = function (sortType) {
        if (!(sortType.trim() === 'views') && !(sortType.trim() === 'name'))
            throw new Error("Invalid parameter supplied to sortType");
        this.sortType = sortType;
        this.selectedSortType$.next(sortType);
    };
    FullMenuService.prototype.getCurrentMenuOptions = function () {
        return this.selectedMenuCategory$.asObservable();
    };
    FullMenuService.prototype.getMenuTabindex = function () {
        return this.selectedTabindexMenu$.asObservable();
    };
    FullMenuService.prototype.setMenuTabindex = function (tabindexMenu) {
        this.tabindexMenu = tabindexMenu;
        this.selectedTabindexMenu$.next(tabindexMenu);
    };
    FullMenuService.prototype.getSelectedTranslationKeyCategory = function () {
        return this.selectedTranslationKeyCategory$.asObservable();
    };
    FullMenuService.prototype.setSelectedTranslationKeyCategory = function (selectedTranslationKeyCategory) {
        this.selectedTranslationKeyCategory = selectedTranslationKeyCategory;
        this.selectedTranslationKeyCategory$.next(selectedTranslationKeyCategory);
    };
    /**
     * Método para recuperação de parâmetros da URL
     * @param route o ActivatedRoute do qual deseja se extrair os parâmetros
     * @param desiredParams array de strings com os nomes dos parâmetros desejados
     */
    FullMenuService.prototype.filterMenuThroughURLParameters = function (route) {
        var _this = this;
        route.paramMap.subscribe(function (params) {
            var menuName = params.get('menuName');
            var menuCategory = params.get('category');
            _this.menuParameters.name = _this.capitalizeString(menuName);
            _this.menuParameters.category = _this.capitalizeString(menuCategory);
            _this.filterMenuByCategory(menuName);
        });
        return this.menu$.asObservable();
    };
    FullMenuService.prototype.filterMenuThroughParameters = function (menuName, menuCategory) {
        this.menuParameters.name = this.capitalizeString(menuName);
        this.menuParameters.category = this.capitalizeString(menuCategory);
        this.filterMenuByCategory(menuName);
        return this.menu$.asObservable();
    };
    FullMenuService.prototype.getSelectedMenu = function (menuName) {
        if (!this.menuList || !menuName)
            return;
        return this.menuList.slice().filter(function (menuCategory) { return menuCategory.name.toLowerCase() === (!menuName ? menuCategory.name.toLowerCase() : menuName.toLowerCase()); })[0];
    };
    FullMenuService.prototype.filterMenuByCategory = function (menuName) {
        var selectedMenu = this.getSelectedMenu(menuName);
        if (selectedMenu) {
            this.menuParameters.menu = selectedMenu;
            this.selectedMenuCategory$.next(selectedMenu.categories);
            this.menu$.next(this.menuParameters);
        }
    };
    FullMenuService.prototype.sortMenu = function (unsortedOptions) {
        var _this = this;
        if (!this.sortType || this.sortType === "views") {
            unsortedOptions = unsortedOptions.slice().sort(function (t1, t2) {
                if (t1.timesViewed > t2.timesViewed) {
                    return -1;
                }
                if (t1.timesViewed < t2.timesViewed) {
                    return 1;
                }
                return 0;
            });
        }
        else {
            unsortedOptions = unsortedOptions.slice().sort(function (t1, t2) {
                var subCategory1 = t1.subCategory;
                var subCategory2 = t2.subCategory;
                if (!subCategory1) {
                    return -1;
                }
                if (subCategory1 > subCategory2) {
                    return 1;
                }
                if (subCategory1 < subCategory2) {
                    return -1;
                }
                return 0;
            });
            unsortedOptions = unsortedOptions.slice().sort(function (t1, t2) {
                var name1 = _this.languageService.translate(t1.translationKey).toLowerCase();
                var name2 = _this.languageService.translate(t2.translationKey).toLowerCase();
                if (t1.subCategory === t2.subCategory) {
                    return name1.localeCompare(name2);
                }
                return 0;
            });
        }
        return unsortedOptions;
    };
    FullMenuService.prototype.capitalizeString = function (text) {
        if (!text)
            return '';
        return text.charAt(0).toUpperCase() + text.slice(1);
    };
    FullMenuService.ngInjectableDef = i0.defineInjectable({ factory: function FullMenuService_Factory() { return new FullMenuService(i0.inject(i1.ActivatedRoute), i0.inject(i2.MenuService), i0.inject(i3.LanguageService)); }, token: FullMenuService, providedIn: "root" });
    return FullMenuService;
}());
export { FullMenuService };
